import React, {Component} from 'react';
import Dialog from './Dialog';
import './Picker.css';
import {connect} from 'react-redux';
import FancyInput from './FancyInput';
import Spinner from './Spinner';
import uiActions from '../chrome/ui.actions';

/**
 * Dumb component to allow dropdown selection in a popup.
 */
export class Picker extends Component {
	render() {
		const {
			dialogProps = {},
			onChangeSearch,
			searchPlaceholder,
			searchValue,
			pickerCallback,
			items = [],
			loading = false,
			selectionMapper = item => item.value,
			cancel,
			title = 'Choose an option'
		} = this.props;

		return (
			<Dialog
				buttons={[]}
				title={title}
				onCancel={cancel}
				className={`Picker ${(dialogProps && dialogProps.className) || ''}`}>
				<div className="Picker-body">
					{this.props.preamble}
					<FancyInput
						value={searchValue}
						placeholder={searchPlaceholder || 'Type to narrow down results'}
						onChange={onChangeSearch}
					/>
					<div className="Picker-results">
						{loading ? (
							<Spinner />
						) : (
							<ul>
								{items &&
									items.map(item => {
										const {value, label, extra} = item;

										return (
											<li
												key={value}
												className="Picker-item"
												onClick={() => pickerCallback && pickerCallback(selectionMapper(item))}>
												<div className="Picker-item-name">{label}</div>
												<div className="Picker-item-extra">{extra}</div>
											</li>
										);
									})}
							</ul>
						)}
					</div>
				</div>
			</Dialog>
		);
	}
}

const ConnectedPicker = connect(
	state => ({
		pickerCallback: state.ui.pickerCallback
	}),
	dispatch => ({
		cancel: () => dispatch(uiActions.uiModal(null))
	})
)(Picker);

export default ConnectedPicker;



// WEBPACK FOOTER //
// ./src/widgets/Picker.js